<template>
  <div class="full-jcalendar" :style="{width:width}">
    <!--日期控件弹窗主体-->
    <div class="full-jcalendar__main">
      <!--单日期模式-->
      <div>
        <div class="full-jcalendar-header">
          <span class="title-year">{{year}}年</span>
          <span style="width:10px;"></span>
          <span class="title-month">{{month}}月</span>
        </div>
        <!-- body  日期和事件 -->
        <div class="full-jcalendar__body">
          <div class="weeks">
            <strong class="week">日</strong>
            <strong class="week">一</strong>
            <strong class="week">二</strong>
            <strong class="week">三</strong>
            <strong class="week">四</strong>
            <strong class="week">五</strong>
            <strong class="week">六</strong>
          </div>
          <!--日期 周  行-->
          <div class="week-row" v-for="(week,$index) in calendarDatas" :key="$index">
            <!--日期 日  单元格-->
            <div
              class="day-cell"
              v-for="(day,$index) in week"
              :key="$index"
              :class="[{'today': day.isToday,'not-optional':isNotOptional(day),'select':day.isSelect,'not-cur-month': !day.isCurMonth ,'work':day.isWork}]"
              @click="onDateSelect(day)"
            >
              <!-- 日期 节气 农历 -->
              <div class="day-number">
                <p class="solar">
                  <span class="is-leap" v-if="day.lDate.isLeap && day.lDate.IDayCn==='初一'">闰</span>
                  <span
                    :class="['number',{'is-today':day.isToday,'is-empty':day.isToday && !day.lDate.isFestival && !day.lDate.isTerm}]"
                  >{{day.day}}</span>
                </p>
                <p
                  class="lunar"
                  v-show="!day.isToday || day.lDate.isFestival || day.lDate.isTerm || day.isToday"
                >
                  <span class="festival" v-if="day.lDate.isFestival">{{day.lDate.festival[0]}}</span>
                  <span class="term" v-else-if="day.lDate.isTerm">{{day.lDate.Term}}</span>
                  <span v-else-if="day.lDate.IDayCn==='初一'">{{day.lDate.IMonthCn.replace('闰','')}}</span>
                  <span v-else>{{day.lDate.IDayCn}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import { calendar } from "./datePicker.js";
import moment from "moment";
export default {
  name: "datePicker",
  props: ["width", "pickerOptions", "workdata", "startMonth"],
  data() {
    return {
      monthDay: "", //月份日期类型，用来比较日期
      year: 0,
      month: 0,
      calendarDatas: [],
      isLeap: false //是否闰月
    };
  },
  created() {
    let month = moment().month(this.startMonth);
    this.monthDay = month.toISOString();
    this.loadCalendar();
    document.addEventListener("click", e => {
      let main = this.$el.querySelector(".full-jcalendar__main");
    });
  },
  methods: {
    isNotOptional(day) {
      if (
        this.pickerOptions != null &&
        this.pickerOptions != undefined &&
        "disabledDate" in this.pickerOptions
      ) {
        return this.pickerOptions.disabledDate(new Date(day.date));
      }
      return false;
    },
    onDateSelect(day) {
      day.isSelect = !day.isSelect;
      day.isWork = !day.isWork;
      if (this.isNotOptional(day)) return;
      this.$emit("change", day);
    },
    loadCalendar() {
      if (this.monthDay == null || this.monthDay == "") {
        this.monthDay = moment().toISOString();
      }
      let startDate = moment(this.monthDay)
        .startOf("month")
        .format("YYYY-MM-DD");
      let currentMonth = moment(startDate);
      this.year = currentMonth.year();
      this.month = currentMonth.month() + 1;
      this.calendarDatas = this.handleCalendar(currentMonth);
    },
    handleCalendar(currentMonth) {
      let start = currentMonth.clone();
      start.subtract(start.day(), "d");
      let calendars = [];
      for (let iWeek = 0; iWeek < 6; iWeek++) {
        let week = [];
        if (iWeek > 0 && !start.isSame(currentMonth, "month")) {
          break;
        }
        for (let iDay = 0; iDay < 7; iDay++) {
          week.push({
            day: start.date(),
            isToday: start.isSame(new Date(), "day"),
            isSelect: false,
            isCurMonth: start.isSame(currentMonth, "month"),
            week: iDay,
            isWork:
              this.workdata[start.clone().format("YYYY-MM-DD")] == 0
                ? true
                : false,
            date: start.clone().format("YYYY-MM-DD"),
            lDate: calendar.getLunar(start.toISOString())
          });
          start.add(1, "d");
        }
        calendars.push(week);
      }
      return calendars;
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("../../scss/calendar.scss");
</style>


// WEBPACK FOOTER //
// src/components/OACalendar/datePicker.vue